import React, { createContext, PropsWithChildren, useContext } from "react";

const UserAgentContext = createContext<string>(null);

export const useUserAgent = () => {
  const context = useContext(UserAgentContext);
  if (!context) {
    throw new Error("useUserAgent must be used within UserAgentProvider");
  }

  return context;
};

export function UserAgentProvider({
  children,
  ua,
}: PropsWithChildren<{ ua: string }>): ReturnType<typeof React.createElement> {
  return React.createElement(
    UserAgentContext.Provider,
    {
      value: ua,
    },
    children
  );
}

/* Types based on react-device-detect library */

export type UserAgentDeviceType =
  | "mobile"
  | "tablet"
  | "browser"
  | "smarttv"
  | "console"
  | "wearable"
  | "embedded";

export type UserAgentSelectors = {
  isSmartTV: boolean;
  isConsole: boolean;
  isWearable: boolean;
  isEmbedded: boolean;
  isMobileSafari: boolean;
  isChromium: boolean;
  isMobile: boolean;
  isMobileOnly: boolean;
  isTablet: boolean;
  isBrowser: boolean;
  isDesktop: boolean;
  isAndroid: boolean;
  isWinPhone: boolean;
  isIOS: boolean;
  isChrome: boolean;
  isFirefox: boolean;
  isSafari: boolean;
  isOpera: boolean;
  isIE: boolean;
  osVersion: string;
  osName: string;
  fullBrowserVersion: string;
  browserVersion: string;
  browserName: string;
  mobileVendor: string;
  mobileModel: string;
  engineName: string;
  engineVersion: string;
  getUA: string;
  isEdge: boolean;
  isYandex: boolean;
  deviceType: UserAgentDeviceType;
  isIOS13: boolean;
  isIPad13: boolean;
  isIPhone13: boolean;
  isIPod13: boolean;
  isElectron: boolean;
  isEdgeChromium: boolean;
  isLegacyEdge: boolean;
  isWindows: boolean;
  isMacOs: boolean;
  isMIUI: boolean;
  isSamsungBrowser: false;
};
